export const memoryStore = new Map();

export const useMemory = () => {
  const setMemoryValue = (key, value) => {
    memoryStore.set(key, value);
  };

  const hasMemoryValue = (key) => {
    return memoryStore.has(key);
  };

  const getMemoryValue = (key) => {
    return memoryStore.get(key);
  };

  return {
    setMemoryValue,
    hasMemoryValue,
    getMemoryValue,
  };
};
